import React, {useEffect, useRef, useState} from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import AutoComplete from '@mui/material/Autocomplete';
import {Box} from '@mui/material';
import "react-datepicker/dist/react-datepicker.css";
import {baseUrl, ipAddress, userLocation, userName} from '../Univ.js'
const EqpPurchaseReturn = (props) => {
    const [consData, setConsData] = useState([]);
    const [items, setItems] = useState([]);
    const [rows, setRows] = useState([{id: '', product: '', batch: '', expiry: '', totqty: '', pprice: '',}]);
    const [subtotal, setSubTotal] = useState(0);
    const currentDate = new Date();
    const formattedDate = currentDate.toLocaleDateString('en-GB').replace(/\//g, '-');
    const [pharmData, setpharmData] = useState({
        "return_no": '',
        "return_type": '',
        "supp": '',
        "product": '',
        "qty": '',
        "netamount": '',
        "gstamount": '',
        "total": '',
        "reason": '',
        "grn_id": '',
        "status": '',
        "addedby": '',
        "ip_add": '',
    });
    useEffect(() => {
        fetchPharmData();
        fetchConsData();
    }, []);
    function fetchPharmData() {
        axios.get(`${baseUrl}eqp-search/?totqty=gt0`)
            .then((pharmResponse) => {
                setItems(pharmResponse.data);
            })
            .catch(error => {
                console.log(error);
            });
    }
    function fetchConsData() {
        axios.get(`${baseUrl}add-supplier/`)
            .then((consResponse) => {
                setConsData(consResponse.data);
            })
            .catch(error => {
                console.log(error);
            });
    }
    const handleConsChange = (event) => {
        const selectedValue = event.target.value;
        setpharmData(prevState => ({...prevState, supp: selectedValue}));
    };
    const handleKeyDown = (e, index) => {
        const newRows = [...rows];
        switch (e.keyCode) {
            // Handle Shift key
            case 16:
                e.preventDefault();
                if (index === rows.length - 1) {
                    newRows.push({id: '', product: '', batch: '', expiry: '', totqty: '', pprice: ''});
                }
                break;
            // Handle arrow up key
            case 90:
                e.preventDefault();
                newRows.splice(index, 1);
                break;
            case 38:
                e.preventDefault();
                if (newRows[index].selectedItem === 0) {
                    newRows[index].selectedItem = items.length - 1;
                } else {
                    newRows[index].selectedItem--;
                }
                setRows(newRows);
                break;
            // Handle arrow down key
            case 40:
                e.preventDefault();
                if (newRows[index].selectedItem === items.length - 1) {
                    newRows[index].selectedItem = 0;
                } else {
                    newRows[index].selectedItem++;
                }
                setRows(newRows);
                break;
            default:
                break;
        }
        setRows(newRows);
    };
    const handleSelect = (val, index, id) => {
        const selectedId = id && id.id ? id.id : 0; // Set selectedId to 0 if id is not found
        const selectedItem = val;
        if (!selectedItem) {
            console.log('Selected item not found');
            return;
        }
        const newRows = [...rows];
        // Check if the selected ID already exists in the rows
        const existingRowIndex = newRows.findIndex(row => row.id === selectedItem.id);
        if (existingRowIndex !== -1) {
            newRows[existingRowIndex].qty += 1;
            newRows[existingRowIndex].remainQty = newRows[existingRowIndex].totqty - newRows[existingRowIndex].qty;
            newRows[existingRowIndex].netamount = newRows[existingRowIndex].qty * newRows[existingRowIndex].pprice;
        } else {
            newRows[index] = {
                id: selectedItem.id,
                product: selectedItem.product,
                qty: '',
                totqty: selectedItem.totqty,
                pprice: selectedItem.pprice,
                expiry: selectedItem.expiry,
                netamount: selectedItem.pprice,
                batch: selectedItem.batch,
                sgst: selectedItem.sgst,
            };
        }
        setRows(newRows);
    };
    const handleAmountChange = (e, index) => {
        const newRows = [...rows];
        newRows[index].qty = parseFloat(e.target.value) || 0;
        newRows[index].pprice = parseFloat(newRows[index].pprice) || 1;
        newRows[index].sgst = parseFloat(newRows[index].sgst);
        const st = newRows[index].sgst * 2;
        const tax1 = (st / 100) * newRows[index].pprice;
        const pp = (tax1 + newRows[index].pprice);
        newRows[index].netamount = parseFloat(pp * newRows[index].qty);
        newRows[index].gstamount = parseFloat(tax1);
        setRows(newRows);
    };
    const handleAddRow = () => {
        const newRows = [...rows];
        newRows.push({id: '', product: '', batch: '', expiry: '', totqty: '', pprice: ''});
        setRows(newRows);
    };
    const inputRefs = useRef([]);
    useEffect(() => {
        inputRefs.current[inputRefs.current.length - 1]?.focus();
    }, [rows.length]);
    const handleDeleteRow = (index) => {
        const newRows = [...rows];
        newRows.splice(index, 1);
        setRows(newRows);
    };
    useEffect(() => {
        let subTotal = 0;
        let newTotal = 0;
        for (let i = 0; i < rows.length; i++) {
            const row = rows[i];
            subTotal += row.netamount;
            newTotal = subTotal;
        }
        setSubTotal(subTotal);
    }, [rows]);
    const handleChange = (e, index) => {
        const {name, value} = e.target;
        setpharmData(prevState => ({...prevState, [name]: value}));
        setRows(prevRows => {
            const newRows = [...prevRows];
            newRows[index] = {
                ...newRows[index],
                [name]: value
            };
            return newRows;
        });
    };
    const formSubmit = (e) => {
        e.preventDefault();
        const dbType = document.getElementById('dbType').value;
        const idsFromRows = rows.map(row => row.id || 0);
        const eqtys = rows.map(row => row.totqty);
        const qtys = rows.map(row => row.qty);
        if (!pharmData.supp) {
            Swal.fire('Error', 'Please select a Supplier.', 'error');
            return;
        }
        const totqtyMap = {};
        eqtys.forEach((totqty, index) => {
            const id = idsFromRows[index];
            const rowTotqty = totqty;
            totqtyMap[id] = rowTotqty - qtys[index];
        });
        const allIds = idsFromRows.join(',');
        axios.post(`${baseUrl}get_eqp_pur_return/`)
            .then(response => {
                const pur_return = response.data.value;
                const _formData = new FormData();
                _formData.append('return_no', pur_return);
                _formData.append('return_type', dbType);
                _formData.append('grn_id', pharmData.grnID);
                _formData.append('supp', pharmData.supp);
                _formData.append('product', rows.map(row => row.id).join(','));
                _formData.append('qty', rows.map(row => row.qty).join(','));
                _formData.append('netamount', rows.map(row => parseFloat(row.netamount).toFixed(2)).join(','));
                _formData.append('gstamount', rows.map(row => row.gstamount).join(','));
                _formData.append('total', subtotal.toFixed(2));
                _formData.append('reason', pharmData.reason);
                _formData.append('status', '1');
                _formData.append('addedby', userName);
                _formData.append('ip_add', ipAddress);
                _formData.append('location', userLocation);
                axios.post(`${baseUrl}eqp-purchase-return/`, _formData)
                    .then(response => {
                        if (response.status === 200 || response.status === 201) {
                            allIds.split(',').forEach((id, index) => {
                                const row = rows[index];
                                const phData = {
                                    totqty: totqtyMap[id],
                                    ip_add: ipAddress,
                                };
                                axios.put(`${baseUrl}update-eqp-qty/${id}/`, phData)
                                    .then(response => {
                                        console.log(response.data);
                                    })
                                    .catch(error => {
                                        console.log(error);
                                    });
                            });
                            Swal.fire({
                                title: 'Pharmacy Bill Generated.',
                                icon: 'success',
                                timer: 2000,
                                showConfirmButton: false
                            });
                            setTimeout(() => {
                                window.location.href = '/eqp-invoice-return/' + pur_return;
                            }, 2000);
                        }
                    });
            })
            .catch(error => {
                console.log(error);
                Swal.fire(
                    'Error!',
                    'Failed to generate unique value. Please try again later.',
                    'error'
                );
            });
    };
    return (
        <section className="container mt-4">
            <form>
                <div className="row">
                    <div className='col-md-6 mb-2'>
                        <label>Supplier:</label>
                        <select name="supp" id="supp" onChange={handleConsChange} className="form-control">
                            <option> Select Supplier</option>
                            {consData.map((category, index) => (
                                <option key={index} value={category.id}>
                                    {category.name}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div className='col-md-6 mb-2'>
                        <label>GRN ID:</label>
                        <input type="text" className="form-control" name="grnID" id="grnID" onChange={handleChange}
                               placeHolder="Grn ID"
                               value={pharmData.grnID}/>
                    </div>
                </div>
                <div className="row">
                    <div className='col-md-6 mb-2'>
                        <label>Purchase Type : </label>
                        <select name="dbType" id="dbType" className="form-control" value={pharmData.ptype}>
                            <option value="Cashless">Cashless Return</option>
                            <option value="Cash">Cash Return</option>
                        </select>
                    </div>
                    <div className='col-md-6 mb-2'>
                        <label>Reason:</label>
                        <input type="text" className="form-control" name="reason" id="reason" onChange={handleChange}
                               placeHolder="Reason"
                               value={pharmData.reason}/>
                    </div>
                </div>

                <div className='table-responsive'>
                    <table className="erp-table-modern">
                        <thead>
                        <tr style={{backgroundColor: '#1bc5ce', color: 'white'}}>
                            <th style={{width: 60}}>ID</th>
                            <th style={{width: 400}}>Equip Name</th>
                            <th style={{width: 50}}>Qty</th>
                            <th style={{width: 90}}>Batch</th>
                            <th style={{width: 90}}>Expiry</th>
                            <th style={{width: 50}}>Qty in Stock</th>
                            <th style={{width: 90}}>pprice 1s</th>
                            <th style={{width: 140}}>Net Amount</th>
                            <th style={{width: 50}}>Action</th>
                        </tr>
                        </thead>
                        <tbody>
                        {rows.map((row, index) => (
                            <tr key={index}>
                                <td>
                                    <input
                                        type="text"
                                        name="id"
                                        value={row.id || 0}
                                        onChange={e => handleChange(e, index)}
                                        style={{width: 80}}
                                        tabIndex={-1}
                                        readOnly
                                    />
                                </td>
                                <td>
                                    <AutoComplete
                                        items={items}
                                        options={items}
                                        sx={{width: 200}}
                                        componentsProps={{
                                            paper: {
                                                sx: {
                                                    width: 800
                                                }
                                            }
                                        }}
                                        fullWidth
                                        onKeyDown={e => handleKeyDown(e, index)}
                                        onChange={(event, val, id) => handleSelect(val, index, id)}
                                        getOptionLabel={(option) => option.product ? option.product : ''}

                                        renderOption={(props, option) => (
                                            <Box component="li" {...props}
                                                 fullWidth
                                                 sx={{
                                                     width: 850,
                                                     height: 50,
                                                     borderRadius: 1,
                                                 }}
                                            >
                                                {option.product ? `${option.product} ID: ${option.id} Expy: (${option.expiry}) Batch: ${option.batch}  pprice: ${option.pprice}
                TQty: ${option.totqty} ` : ''}

                                            </Box>
                                        )}
                                        renderInput={(params) => (
                                            <div ref={params.InputProps.ref}>
                                                <input className="form-control" type="text" {...params.inputProps}
                                                       fullWidth focused autoFocus
                                                       style={{
                                                           background: "#F7EEFF",
                                                           width: 250,
                                                       }}
                                                />
                                            </div>
                                        )}
                                        ref={(el) => inputRefs.current[index] = el}

                                    />
                                </td>
                                <td>
                                    <input
                                        type="number"
                                        style={{width: 90}}
                                        className="ms-2 me-1"
                                        value={row.qty}
                                        name="qty"
                                        onChange={(e) => {
                                            handleChange(e, index);
                                            handleAmountChange(e, index);
                                        }}
                                        onKeyDown={(e) => handleKeyDown(e, index)}
                                        tabIndex={0}
                                        required
                                    />
                                </td>
                                <td>
                                    <input
                                        type="text"
                                        className="ms-2 me-1"
                                        style={{width: 120}}
                                        name="batch"
                                        value={row.batch}
                                        onChange={(e) => handleChange(e, index)}
                                        onKeyDown={(e) => handleKeyDown(e, index)}
                                        tabIndex={-1}
                                        readOnly
                                    />
                                </td>
                                <td>
                                    <input
                                        type="text"
                                        className="ms-2 me-1"
                                        style={{width: 90}}
                                        name="expiry"
                                        value={row.expiry}
                                        onChange={(e) => handleChange(e, index)}
                                        onKeyDown={(e) => handleKeyDown(e, index)}
                                        tabIndex={-1}
                                        readOnly
                                    />
                                </td>
                                <td>
                                    <input
                                        type="number"
                                        className="ms-2 me-1"
                                        style={{width: 100}}
                                        name="totqty"
                                        value={row.totqty}
                                        onChange={(e) => {
                                            handleChange(e, index);
                                            handleAmountChange(e, index);
                                        }}
                                        tabIndex={-1}
                                        readOnly
                                    />
                                </td>
                                <td>
                                    <input
                                        type="number"
                                        className="ms-2 me-1"
                                        style={{width: 90}}
                                        name="pprice"
                                        value={row.pprice}
                                        onChange={(e) => {
                                            handleChange(e, index);
                                            handleAmountChange(e, index);
                                        }}
                                        onKeyDown={(e) => handleKeyDown(e, index)}
                                        tabIndex={-1}
                                        readOnly
                                    />
                                </td>

                                <input
                                    type="number"
                                    className="ms-2 me-1"
                                    style={{width: 90, display: 'none'}}
                                    name="sgst"
                                    value={row.sgst}
                                    onChange={(e) => {
                                        handleChange(e, index);
                                        handleAmountChange(e, index);
                                    }}
                                    onKeyDown={(e) => handleKeyDown(e, index)}
                                    tabIndex={-1}
                                    readOnly
                                />

                                <input
                                    type="text"
                                    className="ms-2 me-1"
                                    style={{width: 90, display: 'none'}}
                                    name="gstamount"
                                    value={row.gstamount}
                                    onChange={(e) => {
                                        handleChange(e, index);
                                        handleAmountChange(e, index);
                                    }}
                                    tabIndex={0}
                                />

                                <td>
                                    <input
                                        type="number"
                                        className="ms-2 me-1"
                                        style={{width: 140}}
                                        name="netamount"
                                        value={parseFloat(row.netamount).toFixed(2)}
                                        onChange={(e) => {
                                            handleChange(e, index);
                                            handleAmountChange(e, index);
                                        }}
                                        onKeyDown={(e) => handleKeyDown(e, index)}
                                        tabIndex={-1}
                                        readOnly
                                    />
                                </td>
                                <td>
                                    <button className="btn btn-danger" type="button"
                                            onClick={() => handleDeleteRow(index)}>Delete
                                    </button>
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                    <button className="btn btn-success addmore mt-4" type="button" onClick={handleAddRow}>Add More
                    </button>

                    <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}
                         className='mb-5'>
                        <button type="button" onClick={formSubmit} className="btn btn-primary mt-4">Submit</button>
                    </div>
                </div>
            </form>
        </section>
    );
};
export default EqpPurchaseReturn;